import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import warrantyGetColor from './warrantyGetColor'

const useWarrantyInputsData = () => {
  const { t } = useTranslation(['warranty', 'devices', 'common', 'people'])
  const { deviceTroubles, inputsData, statuses } = useMemo(() => {
    const statuses = [
      {
        localId: 'review',
        get color() {
          return warrantyGetColor(this.localId)
        },
        label: t('warranty:status.review'),
        data: [],
      },
      {
        localId: 'repair',
        get color() {
          return warrantyGetColor(this.localId)
        },
        label: t('warranty:status.repair'),
        data: [],
      },
      {
        localId: 'repaired',
        get color() {
          return warrantyGetColor(this.localId)
        },
        label: t('warranty:status.repaired'),
        data: [],
      },
      {
        localId: 'refusal',
        get color() {
          return warrantyGetColor(this.localId)
        },
        label: t('warranty:status.refusal'),
        data: [],
      },
    ]

    const deviceTroubles = {
      intercom: [
        {
          label: t('form.intercom.sound.label'),
          localId: 'sound',
          options: [
            {
              label: t('form.intercom.sound.sound_trouble_1'),
              errNum: 'sound_trouble_1',
            },
            {
              label: t('form.intercom.sound.sound_trouble_2'),
              errNum: 'sound_trouble_2',
            },
            {
              label: t('form.intercom.sound.sound_trouble_3'),
              errNum: 'sound_trouble_3',
            },
            {
              label: t('form.intercom.sound.sound_trouble_4'),
              errNum: 'sound_trouble_4',
            },
            {
              label: t('form.intercom.sound.sound_trouble_5'),
              errNum: 'sound_trouble_5',
            },
            { label: t('form.not_recognized'), errNum: 'not_recognized' },
          ],
        },
        {
          label: t('form.intercom.intercom_camera_v2.label'),
          localId: 'intercom_camera_v2',
          options: [
            {
              label: t(
                'form.intercom.intercom_camera_v2.intercom_camera_trouble_1'
              ),
              errNum: 'intercom_camera_trouble_1',
            },
            {
              label: t(
                'form.intercom.intercom_camera_v2.intercom_camera_trouble_2'
              ),
              errNum: 'intercom_camera_trouble_2',
            },
            {
              label: t(
                'form.intercom.intercom_camera_v2.intercom_camera_trouble_3'
              ),
              errNum: 'intercom_camera_trouble_3',
            },
            { label: t('form.not_recognized'), errNum: 'not_recognized' },
          ],
        },
        {
          label: t('form.intercom.lock_v2.label'),
          localId: 'lock_v2',
          options: [
            {
              label: t('form.intercom.lock_v2.lock_trouble_1'),
              errNum: 'lock_trouble_1',
            },
            {
              label: t('form.intercom.lock_v2.lock_trouble_2'),
              errNum: 'lock_trouble_2',
            },
            { label: t('form.not_recognized'), errNum: 'not_recognized' },
          ],
        },
        {
          label: t('form.intercom.net.label'),
          localId: 'net',
          options: [
            {
              label: t('form.intercom.net.net_trouble_1'),
              errNum: 'net_trouble_1',
            },
            {
              label: t('form.intercom.net.net_trouble_2'),
              errNum: 'net_trouble_2',
            },
            { label: t('form.not_recognized'), errNum: 'not_recognized' },
          ],
        },
        {
          label: t('form.intercom.call.label'),
          localId: 'call',
          options: [
            {
              label: t('form.intercom.call.call_trouble_1'),
              errNum: 'call_trouble_1',
            },
            {
              label: t('form.intercom.call.call_trouble_2'),
              errNum: 'call_trouble_2',
            },
            {
              label: t('form.intercom.call.call_trouble_3'),
              errNum: 'call_trouble_3',
            },
            { label: t('form.not_recognized'), errNum: 'not_recognized' },
          ],
        },
        {
          label: t('form.intercom.intercom_general_v2.label'),
          localId: 'intercom_general_v2',
          options: [
            {
              label: t(
                'form.intercom.intercom_general_v2.intercom_general_trouble_1'
              ),
              errNum: 'intercom_general_trouble_1',
            },
            {
              label: t(
                'form.intercom.intercom_general_v2.intercom_general_trouble_2'
              ),
              errNum: 'intercom_general_trouble_2',
            },
            {
              label: t(
                'form.intercom.intercom_general_v2.intercom_general_trouble_3'
              ),
              errNum: 'intercom_general_trouble_3',
            },
            { label: t('form.not_recognized'), errNum: 'not_recognized' },
          ],
        },
      ],
      camera: [
        {
          label: t('form.camera.label'),
          localId: 'camera',
          options: [
            {
              label: t('form.camera.camera_trouble_1'),
              errNum: 'camera_trouble_1',
            },
            {
              label: t('form.camera.camera_trouble_2'),
              errNum: 'camera_trouble_2',
            },
            {
              label: t('form.camera.camera_trouble_3'),
              errNum: 'camera_trouble_3',
            },
            { label: t('form.not_recognized'), errNum: 'not_recognized' },
          ],
        },
      ],
      deprecatedCamera: [
        {
          label: t('form.camera.troubles'),
          localId: 'inside_camera',
          type: 'radio',
          options: [
            {
              label: t('form.camera.broken'),
              errNum: 'inside_camera_trouble_0',
            },
            {
              label: t('form.camera.other'),
              errNum: 'inside_camera_trouble_1',
            },
          ],
        },
      ],
      deprecatedIntercom: [
        {
          label: t('form.intercom.tap'),
          localId: 'tap',
          options: [
            { label: t('form.intercom.no_call'), errNum: 'tap_trouble_0' },
            { label: t('form.intercom.no_reaction'), errNum: 'tap_trouble_1' },
            {
              label: t('form.intercom.no_reaction_door_open'),
              errNum: 'tap_trouble_2',
            },
            { label: t('form.intercom.whistle'), errNum: 'tap_trouble_3' },
            { label: t('form.intercom.audibility'), errNum: 'tap_trouble_4' },
          ],
        },

        {
          label: t('form.intercom.general'),
          localId: 'intercom_general',
          options: [
            {
              label: t('form.intercom.offline'),
              errNum: 'intercom_general_trouble_0',
            },
            {
              label: t('form.intercom.no_reaction_keys'),
              errNum: 'intercom_general_trouble_1',
            },
            {
              label: t('form.intercom.other'),
              errNum: 'intercom_general_trouble_2',
            },
          ],
        },
        {
          label: t('form.intercom.camera'),
          localId: 'intercom_camera',
          type: 'radio',
          options: [
            {
              label: t('form.intercom.clicks'),
              errNum: 'intercom_camera_trouble_0',
            },
            {
              label: t('form.intercom.no_clicks'),
              errNum: 'intercom_camera_trouble_1',
            },
          ],
        },
        {
          label: t('form.intercom.lock'),
          localId: 'lock',
          options: [
            {
              label: t('form.intercom.lock_button'),
              errNum: 'lock_trouble_0',
            },
            {
              label: t('form.intercom.lock_key'),
              errNum: 'lock_trouble_1',
            },
          ],
        },
        {
          type: 'radio',
          localId: 'mechanical_damage',
          label: t('form.intercom.damage'),
          options: [
            {
              label: t('form.intercom.damage_yes'),
              errNum: true,
            },
            {
              label: t('form.intercom.damage_no'),
              errNum: false,
            },
          ],
        },
      ],
    }

    const inputsData = [
      {
        localId: 'first_column',
        fields: [
          {
            label: t('devices:serial_number'),
            name: 'device_number',
            required: true,
          },
          {
            label: t('form.company_name'),
            name: 'partner_name',
            required: true,
          },
          {
            label: t('people:contact_person'),
            name: 'full_name',
            required: true,
          },
        ],
      },

      {
        localId: 'second_column',
        fields: [
          {
            label: 'Email',
            name: 'email',
            required: true,
            type: 'email',
          },
          {
            label: t('form.phone'),
            name: 'phone',
            required: true,
            type: 'phone',
          },
        ],
      },
    ]
    return { deviceTroubles, inputsData, statuses }
  }, [t])

  return { deviceTroubles, inputsData, statuses }
}

export default useWarrantyInputsData
